export type TemplateUtiler = {
	/** @description Creates a new RegExp object from the given string pattern.*/
	regex$: (pattern: string) => RegExp;
};

export function getTemplateUtiler(): TemplateUtiler {
	const utiler: TemplateUtiler = {
		regex$: (pattern: string) => tryCatchFn(() => new RegExp(pattern), {errorLog: 'Error creating regex pattern'}),
	};
	return utiler;
}
